import axios from "axios";

export const createStaffMember = async (username, systemUserVOToCreate) => {
    try {
        const {data} = await axios.post("/api/systemUser/create", {username, systemUserVOToCreate});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}
export const retrieveStaffMember = async (username, systemUserExternalReference) => {
    try {
        const {data} = await axios.post("/api/systemUser/view", {username, systemUserExternalReference});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const retrieveAllStaffMembers = async (username) => {
    try {
        const {data} = await axios.get("/api/systemUser/viewAll?username=" + username);
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const retrieveLoggedInSystemUser = async (username) => {
    try {
        const {data} = await axios.get("/api/systemUser/retrieveLoggedInSystemUser?username=" + username);
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const updateStaffMember = async (username, systemUserVOToUpdate) => {
    try {
        const {data} = await axios.put("/api/systemUser/update", {username, systemUserVOToUpdate});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const deleteStaffMember = async (username, externalReference) => {
    try {
        const {data} = await axios.delete("/api/systemUser/delete", {data: {username, externalReference}});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}
